<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <form action="">
      <div
        class="modal-card"
        style="width: auto"
      >
        <header class="modal-card-head">
          <p class="modal-card-title">{{ mode === 'edit' ? 'Editar' : 'Criar' }} Plano Recorrente</p>
        </header>
        <section class="modal-card-body">
          <div style="min-width: 330px">
            <!-- Nome -->
            <b-field
              label="Nome"
              class="mw-300"
            >
              <b-input
                v-model="plan.name"
                placeholder="Nome"
              />
            </b-field>
            <!-- Valor -->
            <b-field
              label="Valor"
              class="mw-300"
            >
              <b-input
                v-model="plan.amountPerPayment"
                v-currency
                placeholder="Valor"
              />
            </b-field>

            <!-- Periodicidade -->
            <b-field label="Periodicidade">
              <b-select
                placeholder="Periodicidade"
                v-model="plan.period"
              >
                <option
                  v-for="option in periods"
                  :value="option.value"
                  :key="option.value"
                >
                  {{ option.label }}
                </option>
              </b-select>
            </b-field>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >Cancelar</button>
          <button
            class="button is-primary"
            @click.prevent="submit()"
          >{{mode == 'create' ? 'Criar' : 'Salvar'}}</button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { plansCollection } from '../../firebaseConfig'

const periods = [
  { label: 'Mensal', value: 'MONTHLY' },
  { label: 'Semanal', value: 'WEEKLY' },
  { label: 'Bimestral', value: 'BIMONTHLY' },
  { label: 'Trimestral', value: 'TRIMONTHLY' },
  { label: 'Semestral', value: 'SEMIANNUALLY' },
  { label: 'Anual', value: 'YEARLY' }
]

export default {
  props: {
    planData: Object,
    mode: {
      type: String,
      default: 'create',
      validator: value => ['create', 'edit'].includes(value)
    }
  },
  data () {
    return {
      periods,
      performingRequest: false,
      plan: this.planData,
      name: '',
      lastName: '',
      email: '',
      premiumData: {
        premiumSince: null,
        premiumUntil: null
      }
    }
  },
  created () {
    if (this.mode === 'edit') return
    this.plan = {
      name: '',
      amountPerPayment: '',
      period: 'MONTHLY'
    }
  },
  methods: {
    async submit () {
      const method = this.mode
      this[method]()
    },
    async create () {
      const { name, period } = this.plan
      let { amountPerPayment } = this.plan

      amountPerPayment = this.$parseCurrency(amountPerPayment).toFixed(2)

      const value = parseFloat(amountPerPayment)

      if (value < 1 || value > 2000) {
        return this.$toasted.error('O valor do plano deve estar entre R$1,00 e R$2.000,00')
      }

      try {
        this.performingRequest = true
        const doc = await plansCollection.add({ name, amountPerPayment, period, active: true })
        doc.update({ id: doc.id })
      } catch (error) {
        console.error(error)
        this.$toasted.error('Não foi possível salvar as alterações. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
        this.$parent.close()
        this.$toasted.success('Alterações salvas com sucesso')
      }

      try {
        this.performingRequest = true
        await this.$store.dispatch('fetchPlans')
      } catch (error) {
        this.$toasted.error('Um erro ocorreu ao carregar os planos. Tente novamente mais tarde.')
      } finally {
        this.performingRequest = false
      }
    },
    async edit () {
      try {
        this.performingRequest = true
        const { name, period } = this.plan
        let { amountPerPayment } = this.plan

        amountPerPayment = this.$parseCurrency(amountPerPayment).toFixed(2)

        await plansCollection
          .doc(this.plan.id)
          .set({ name, amountPerPayment, period })
      } catch (error) {
        console.error(error)
        this.$toasted.error('Não foi possível salvar as alterações. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
        this.$parent.close()
        this.$toasted.success('Alterações salvas com sucesso')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
